export const BALANCES_STRINGS = {
  TITLE: "Saldos de vacaciones",

  TEXT_TABLE_LOADING: "Cargando...",
  TEXT_TABLE_RESULTS:
    "Mostrando {first} a {last} de {totalRecords} saldos de vacaciones",

  INITIAL_LOADING_LABEL: "Carga inicial",

  DIALOG_HEADER_BASE_SYSTEM: "Importar desde sistema base",
  DIALOG_HEADER_TEMPLATE: "Importar con plantilla",

  BUTTON_CANCEL: "Cancelar",
  BUTTON_BACK: "Regresar",
  BUTTON_SAVE: "Guardar",
  BUTTON_CONTINUE: "Continuar",

  OPTION_SELECTION_DESCRIPTION:
    "Para comenzar, elige cómo deseas cargar los saldos iniciales de vacaciones de tus colaboradores.",
  OPTION_BASE_SYSTEM_TITLE: "Importar desde [system]",
  OPTION_BASE_SYSTEM_DESCRIPTION:
    "Importa el control de vacaciones desde tu sistema base a Colabora, sin volver a capturar los saldos.",
  OPTION_TEMPLATE_TITLE: "Importar con plantilla",
  OPTION_TEMPLATE_DESCRIPTION:
    "Descarga la plantilla, complétala y súbela para capturar todos los saldos en un solo paso.",

  IMPORT_BASE_SYSTEM_ALL_LABEL: "Todos los colaboradores",
  IMPORT_BASE_SYSTEM_ALL_DESCRIPTION:
    "Esta opción eliminará los saldos existentes en Colabora y los reemplazará con la información de {systemName}, para todos los colaboradores.",
  IMPORT_BASE_SYSTEM_NO_BALANCES_LABEL: "Sólo colaboradores sin saldo inicial",
  IMPORT_BASE_SYSTEM_NO_BALANCES_DESCRIPTION:
    "Esta opción sólo va a importar los saldos de los colaboradores que aún no tienen registro de saldo inicial en Colabora.",

  TEXT_TOOLTIP_EDIT: "Editar saldo del colaborador",

  EXPORT_NO_DATA: "No hay saldos de vacaciones para exportar a Excel.",
  EXPORT_SUCCESS:
    "Los saldos de vacaciones se han exportado a Excel correctamente.",
  EXPORT_ERROR:
    "Error al exportar los saldos de vacaciones a Excel. Por favor, intente nuevamente.",

  IMPORT_TEMPLATE_DOWNLOAD_LINK_TEXT: "Descarga la plantilla",
  IMPORT_TEMPLATE_INSTRUCTIONS:
    ", completa la información requerida y luego súbela desde esta pantalla para importar tus datos de forma automática.",
  IMPORT_TEMPLATE_DOWNLOADING: "Descargando plantilla",
  IMPORT_TEMPLATE_UPLOAD_TITLE_PREFIX: "Haz clic para",
  IMPORT_TEMPLATE_UPLOAD_TITLE_LINK: "subir tu archivo",
  IMPORT_TEMPLATE_UPLOAD_TITLE_SUFFIX: "o arrástralo aquí",
  IMPORT_TEMPLATE_UPLOAD_FORMATS:
    "Formatos compatibles: XLS, XLSX o CSV - Tamaño máximo 50MB",
  IMPORT_TEMPLATE_UPLOAD_AREA_LABEL: "Área de subida de archivo",

  IMPORT_PROGRESS_HEADER: "Importando saldos",
  IMPORT_PROGRESS_MESSAGE:
    "Este proceso puede tardar unos segundos en lo que obtenemos la información",

  IMPORT_SUCCESS_HEADER: "Importación exitosa",
  IMPORT_SUCCESS_MESSAGE: "Se importó correctamente la información",

  IMPORT_ERROR_HEADER: "Importación con error",
  IMPORT_ERROR_MESSAGE:
    "Se produjo un error al importar información, intente de nuevo más tarde",
  IMPORT_TEMPLATE_ERROR_MESSAGE:
    "Algunos registros tuvieron error, corrija el problema e intente de nuevo",

  IMPORT_ALL_NO_DATA_ALERT:
    "Ya todos los colaboradores tienen saldos iniciales, no se importará información",

  BUTTON_CLOSE: "Cerrar",
} as const;

export const ACCRUALS_TABLE_STRINGS = {
  GET_DATA_ERROR_TITLE: "Error al obtener los saldos de vacaciones",

  TEXT_TABLE_LOADING: "Cargando...",
  TEXT_TABLE_RESULTS: "Mostrando {first} a {last} de {totalRecords} saldos",

  TEXT_TOOLTIP_EDIT: "Editar saldo",
  TEXT_TOOLTIP_DELETE: "Eliminar saldo",
  TEXT_TOOLTIP_SAVE: "Guardar saldo",
  TEXT_TOOLTIP_CANCEL: "Cancelar edición",

  DELETE_CONFIRM_MESSAGE:
    "¿Está seguro que desea eliminar este registro? Esta acción no se puede deshacer",

  DELETE_SUCCESS: "El saldo se eliminó correctamente.",
  DELETE_PARTIAL_FAILURE: "Algunos saldos no pudieron eliminarse.",
  DELETE_ERROR: "Error al eliminar el saldo. Por favor, intente nuevamente.",

  UPDATE_SUCCESS: "El saldo se actualizó correctamente.",
  UPDATE_PARTIAL_FAILURE: "Algunos saldos no pudieron actualizarse.",
  UPDATE_ERROR: "Error al actualizar el saldo. Por favor, intente nuevamente.",

  BUTTON_ADD_ACCRUAL: "Abono vacaciones",
  CREATE_SUCCESS: "El saldo se creó correctamente.",
  CREATE_PARTIAL_FAILURE: "Algunos saldos no pudieron crearse.",
  CREATE_ERROR: "Error al crear el saldo. Por favor, intente nuevamente.",
} as const;
